// src/pages/NewsPage.js
import React, { useEffect, useState } from "react";
import sanityClient from "../sanity";
import { useParams } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";
import "../styles/NewsPage.css";

function NewsPage() {
  const { index } = useParams();
  const [newsItem, setNewsItem] = useState(null);

useEffect(() => {
  sanityClient
    .fetch(
      `*[_type == "news"][${index}]{
        title, content, publishedAt, "imageUrl": image.asset->url
      }`
    )
    .then((data) => {
      setNewsItem(data);

      // Step 1: Jump instantly to top (no animation, prevents wrong scroll)
      window.scrollTo({ top: 0, behavior: "auto" });

      // Step 2: After short delay, apply smooth offset down from top
      setTimeout(() => {
        const headerOffset = window.innerHeight * 0.2; // 20% offset
        window.scrollTo({
          top: headerOffset,
          behavior: "smooth",
        });
      }, 50); // wait just a tick for layout
    })
    .catch(console.error);
}, [index]);

  if (!newsItem) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
        <p>Loading news item...</p>
      </div>
    );
  }

  return (
    <div className="news-page-wrapper">
      {/* Hero for navbar background */}
      <div className="news-hero">
        <h1 className="news-hero-title"> . </h1>
      </div>

      <Container className="news-page-container">
        <div className="news-article">
          {/* Left: Image */}
          {newsItem.imageUrl && (
            <div className="news-image-col">
              <div className="news-image">
                <img
                  src={newsItem.imageUrl}
                  alt={newsItem.title}
                  className="news-img"
                />
              </div>
            </div>
          )}

          <div className="news-content">
            <h2 className="news-title">{newsItem.title}</h2>
            <p className="news-published">
              Published on:{" "}
              {new Date(newsItem.publishedAt).toLocaleDateString()}
            </p>
          </div>
          {/* Keep the full article below the image to prevent any overlap. */}
          <div className="news-body news-body-below">
            <div className="news-text">{newsItem.content}</div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default NewsPage;
